// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fundo geral escuro */
.wavoip-page-bg {
  min-height: 100vh;
  background: #181c23;
  padding: 40px 0;
}

.wavoip-container {
  background: #23272f;
  border-radius: 12px;
  max-width: 1100px;
  margin: 0 auto;
  padding: 32px 32px 24px 32px;
  box-shadow: 0 4px 32px 0 #00000030;
}

.wavoip-title {
  color: #fff;
  font-size: 2rem;
  margin-bottom: 28px;
  font-weight: 600;
}

.wavoip-error {
  color: #ff5c5c;
  background: #2a1a1a;
  border-radius: 6px;
  padding: 8px 16px;
  margin-bottom: 10px;
  font-weight: 500;
}

.wavoip-add-bar {
  display: flex;
  gap: 12px;
  margin-bottom: 28px;
}

.wavoip-input {
  background: #23272f;
  border: 1.5px solid #353b48;
  color: #fff;
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 1rem;
  outline: none;
  transition: border 0.2s;
}
.wavoip-input:focus {
  border: 1.5px solid #007bff;
}

.wavoip-btn {
  border: none;
  border-radius: 6px;
  padding: 8px 18px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  background: #353b48;
  color: #fff;
  transition: background 0.2s, color 0.2s;
}
.wavoip-btn-primary {
  background: #128C7E;
  color: #fff;
}
.wavoip-btn-primary:hover {
  background: #075E54;
}
.wavoip-btn-edit {
  background: #128C7E;
  margin-right: 8px;
}
.wavoip-btn-edit:hover {
  background: #075E54;
}
.wavoip-btn-delete {
  background: #dc3545;
}
.wavoip-btn-delete:hover {
  background: #a71d2a;
}
.wavoip-btn-visibility {
  background: #6c757d;
  margin-left: 8px;
}
.wavoip-btn-visibility:hover {
  background: #5a6268;
}

.wavoip-loading {
  color: #fff;
  margin-bottom: 16px;
}

.wavoip-table-wrapper {
  overflow-x: auto;
  border-radius: 10px;
  background: #20232a;
  box-shadow: 0 2px 12px 0 #00000020;
}

.wavoip-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  color: #fff;
  font-size: 1rem;
}
.wavoip-table th, .wavoip-table td {
  padding: 14px 12px;
  text-align: left;
}
.wavoip-table th {
  background: #23272f;
  font-weight: 600;
  border-bottom: 2px solid #353b48;
}
.wavoip-table tr {
  transition: background 0.2s;
}
.wavoip-table tbody tr:hover {
  background: #23272f;
}
.wavoip-table td {
  border-bottom: 1px solid #353b48;
}

.wavoip-status-ok {
  color: #4caf50;
  font-weight: 600;
}
.wavoip-status-bad {
  color: #ff5c5c;
  font-weight: 600;
}
.wavoip-status-warn {
  color: #ffb300;
  font-weight: 500;
}
.wavoip-status-wait {
  color: #b0b0b0;
  font-style: italic;
}
.wavoip-available {
  color: #4caf50;
  font-weight: 600;
}
.wavoip-unavailable {
  color: #ff5c5c;
  font-weight: 600;
}

/* Modal */
.wavoip-modal-bg {
  position: fixed;
  top: 0; left: 0; width: 100vw; height: 100vh;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}
.wavoip-modal {
  background: #23272f;
  color: #fff;
  border-radius: 10px;
  padding: 32px 28px 24px 28px;
  min-width: 340px;
  box-shadow: 0 4px 32px 0 #00000050;
}
.wavoip-modal-field {
  margin-bottom: 18px;
  display: flex;
  flex-direction: column;
}
.wavoip-modal-field label {
  margin-bottom: 6px;
  color: #b0b0b0;
  font-size: 0.98rem;
}
.wavoip-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
}
.wavoip-modal-warn {
  color: #ff5c5c;
  font-size: 0.98rem;
  margin-top: 8px;
  margin-bottom: 0;
}

.wavoip-btn svg {
  font-size: 10px !important;
}

.wavoip-table th:last-child, .wavoip-table td:last-child {
  min-width: 160px !important;
}

/* Ícone de visibilidade inline */
.wavoip-visibility-icon {
  cursor: pointer;
  color: #6c757d;
  font-size: 14px;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.wavoip-visibility-icon:hover {
  color: #007bff;
} `, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,YAAY,EAAE,aAAa;EAC5C,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Fundo geral escuro */\n.wavoip-page-bg {\n  min-height: 100vh;\n  background: #181c23;\n  padding: 40px 0;\n}\n\n.wavoip-container {\n  background: #23272f;\n  border-radius: 12px;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 32px 32px 24px 32px;\n  box-shadow: 0 4px 32px 0 #00000030;\n}\n\n.wavoip-title {\n  color: #fff;\n  font-size: 2rem;\n  margin-bottom: 28px;\n  font-weight: 600;\n}\n\n.wavoip-error {\n  color: #ff5c5c;\n  background: #2a1a1a;\n  border-radius: 6px;\n  padding: 8px 16px;\n  margin-bottom: 10px;\n  font-weight: 500;\n}\n\n.wavoip-add-bar {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.wavoip-input {\n  background: #23272f;\n  border: 1.5px solid #353b48;\n  color: #fff;\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-size: 1rem;\n  outline: none;\n  transition: border 0.2s;\n}\n.wavoip-input:focus {\n  border: 1.5px solid #007bff;\n}\n\n.wavoip-btn {\n  border: none;\n  border-radius: 6px;\n  padding: 8px 18px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  background: #353b48;\n  color: #fff;\n  transition: background 0.2s, color 0.2s;\n}\n.wavoip-btn-primary {\n  background: #128C7E;\n  color: #fff;\n}\n.wavoip-btn-primary:hover {\n  background: #075E54;\n}\n.wavoip-btn-edit {\n  background: #128C7E;\n  margin-right: 8px;\n}\n.wavoip-btn-edit:hover {\n  background: #075E54;\n}\n.wavoip-btn-delete {\n  background: #dc3545;\n}\n.wavoip-btn-delete:hover {\n  background: #a71d2a;\n}\n.wavoip-btn-visibility {\n  background: #6c757d;\n  margin-left: 8px;\n}\n.wavoip-btn-visibility:hover {\n  background: #5a6268;\n}\n\n.wavoip-loading {\n  color: #fff;\n  margin-bottom: 16px;\n}\n\n.wavoip-table-wrapper {\n  overflow-x: auto;\n  border-radius: 10px;\n  background: #20232a;\n  box-shadow: 0 2px 12px 0 #00000020;\n}\n\n.wavoip-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  color: #fff;\n  font-size: 1rem;\n}\n.wavoip-table th, .wavoip-table td {\n  padding: 14px 12px;\n  text-align: left;\n}\n.wavoip-table th {\n  background: #23272f;\n  font-weight: 600;\n  border-bottom: 2px solid #353b48;\n}\n.wavoip-table tr {\n  transition: background 0.2s;\n}\n.wavoip-table tbody tr:hover {\n  background: #23272f;\n}\n.wavoip-table td {\n  border-bottom: 1px solid #353b48;\n}\n\n.wavoip-status-ok {\n  color: #4caf50;\n  font-weight: 600;\n}\n.wavoip-status-bad {\n  color: #ff5c5c;\n  font-weight: 600;\n}\n.wavoip-status-warn {\n  color: #ffb300;\n  font-weight: 500;\n}\n.wavoip-status-wait {\n  color: #b0b0b0;\n  font-style: italic;\n}\n.wavoip-available {\n  color: #4caf50;\n  font-weight: 600;\n}\n.wavoip-unavailable {\n  color: #ff5c5c;\n  font-weight: 600;\n}\n\n/* Modal */\n.wavoip-modal-bg {\n  position: fixed;\n  top: 0; left: 0; width: 100vw; height: 100vh;\n  background: rgba(0,0,0,0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n.wavoip-modal {\n  background: #23272f;\n  color: #fff;\n  border-radius: 10px;\n  padding: 32px 28px 24px 28px;\n  min-width: 340px;\n  box-shadow: 0 4px 32px 0 #00000050;\n}\n.wavoip-modal-field {\n  margin-bottom: 18px;\n  display: flex;\n  flex-direction: column;\n}\n.wavoip-modal-field label {\n  margin-bottom: 6px;\n  color: #b0b0b0;\n  font-size: 0.98rem;\n}\n.wavoip-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 10px;\n}\n.wavoip-modal-warn {\n  color: #ff5c5c;\n  font-size: 0.98rem;\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n\n.wavoip-btn svg {\n  font-size: 10px !important;\n}\n\n.wavoip-table th:last-child, .wavoip-table td:last-child {\n  min-width: 160px !important;\n}\n\n/* Ícone de visibilidade inline */\n.wavoip-visibility-icon {\n  cursor: pointer;\n  color: #6c757d;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  transition: color 0.2s;\n}\n\n.wavoip-visibility-icon:hover {\n  color: #007bff;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
